import { Link } from "react-router-dom";
import { useContext } from "react";
import { AlertTriangle } from "lucide-react";
import { AuthContext } from "../../Moduels/Context/AuthContext";
import { useFoundationSetup } from "../../Moduels/Context/FoundationSetupContext";

export default function GlobalSetupNotification() {
  const { role } = useContext(AuthContext);
  const ctx = useFoundationSetup();
  const isAdmin = ["admin", "superadmin", "super_admin"].includes(String(role || "").toLowerCase());

  if (!isAdmin || !ctx || ctx.status.loading || ctx.status.complete) return null;

  return (
    <div className="global-setup-notice" role="alert">
      <span className="global-setup-notice__icon" aria-hidden>
        <AlertTriangle size={16} strokeWidth={2} />
      </span>
      <span className="global-setup-notice__text">
        Initial setup is not complete. Add departments, designations, and locations before full payroll use.
      </span>
      <Link to="/Setup" className="global-setup-notice__action">
        Complete Initial Setup →
      </Link>
    </div>
  );
}
